import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import { NOTIFICATION_FEED_FILTERS, NotificationFeedFilter } from './notification-feed-filter';

const filterMessages = defineMessages({
  all: {
    id: 'notifications.feed.filterAll',
    defaultMessage: 'Todas',
  },
  unread: {
    id: 'notifications.feed.filterUnread',
    defaultMessage: 'No leídas',
  },
  read: {
    id: 'notifications.feed.filterRead',
    defaultMessage: 'Leídas',
  },
});

export type NotificationFeedFilterSelectProps = {
  value: NotificationFeedFilter;
  onChange: (next: NotificationFeedFilter) => void;
};

/**
 * All / Unread / Read filter select for the MUI notifications feed header.
 */
export function NotificationFeedFilterSelect({
  value,
  onChange,
}: NotificationFeedFilterSelectProps) {
  const $t = useIntl().formatMessage;

  function handleChange(event: SelectChangeEvent<NotificationFeedFilter>) {
    onChange(event.target.value as NotificationFeedFilter);
  }

  return (
    <Select
      size="small"
      variant="standard"
      disableUnderline
      value={value}
      onChange={handleChange}
      sx={{
        typography: 'caption',
        color: 'text.secondary',
        '& .MuiSelect-select': { py: 0, pr: 3 },
      }}
    >
      {NOTIFICATION_FEED_FILTERS.map((filter) => (
        <MenuItem key={filter} value={filter} sx={{ typography: 'caption' }}>
          {$t(filterMessages[filter])}
        </MenuItem>
      ))}
    </Select>
  );
}
